import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { StripePaymentElementOptions } from '@stripe/stripe-js';
import { IPaymentSetupData } from 'fitbeat.models';
import React, { FunctionComponent, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Button, ButtonSize } from '../../components';
import Theme from '../../theme';

interface IProps {
  t: (key: string, options?: any) => string;
  returnUrl: string;
  paymentMethodAdded?: () => void;
  paymentSetupData?: IPaymentSetupData;
  stripeCustomerId: string;
  userId: string;
}

export const StripePaymentElement: FunctionComponent<IProps> = ({ t, returnUrl }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [formReady, setFormReady] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsLoading(true);

    if (!stripe || !elements) {
      return;
    }
    // @ts-ignore
    const { error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: returnUrl,
      },
      redirect: 'always',
    });

    if (error) {
      setErrorMessage(error.message || 'Failed to confirm card setup. Please try again');
    }
    setIsLoading(false);
  };

  const options: StripePaymentElementOptions = {
    terms: {
      auBecsDebit: 'never',
      card: 'never',
    },
  };

  return (
    <View style={styles.formContainer}>
      <PaymentElement onReady={() => setFormReady(true)} options={options} />
      {
        errorMessage &&
        <Text style={styles.errorText}>{errorMessage}</Text>
      }
      {
        formReady &&
        <Button
          containerStyle={{ marginTop: 20 }}
          isLoading={isLoading}
          size={ButtonSize.MEDIUM}
          fontColor={Theme.WHITE}
          title={t('activate')}
          onPress={handleSubmit}
        />
      }
    </View>
  );
};

const styles = StyleSheet.create({
  formContainer: {
    width: '100%',
    flex: 1,
  },
  errorText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.RED,
  },
  loadingContainer: {
    height: 300,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
